import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import PropTypes from 'prop-types'
import { getUserInfo, getUserToken } from '../../utils/localData'

const PublicRoute = ({ component: Component, ...rest }) => {
  const renderedComponent = (props) => {
    const userInfo = getUserInfo()
    const userToken = getUserToken()

    if (userInfo && userToken) {
      return <Redirect to='/home' />
    }
    return <Component {...props} />
  }

  return <Route {...rest} render={renderedComponent} />
}

export default PublicRoute

PublicRoute.propTypes = {
  component: PropTypes.elementType,
}
